<template>
  <paginated-list
    :actions="actions"
    :columns="columns"
    :query="query"
    loading-message="Loading Projects"
    no-results-message=""
    service="projects">
    <template v-slot:none>
      <p>No projects found, <a href="#" @click.prevent="$modal.show('#createProjectModal')">create a project</a> now?</p>
      <create-project-modal />
    </template>
  </paginated-list>
</template>

<script>
import CreateProjectModal from './CreateProjectModal.vue'
import PaginatedList from './PaginatedList.vue'

export default {
  created () {
    if (this.$auth.admin()) {
      if (this.owner) this.query.user = this.owner
    } else {
      this.query.user = this.$auth.user._id
    }
  },

  data () {
    return {
      query: {}
    }
  },

  name: 'ProjectFilter',

  components: {
    CreateProjectModal,
    PaginatedList
  },

  props: {
    owner: String
  },

  computed: {
    actions () {
      return [{
        text: 'View',
        to: {
          name: 'projects.dashboard'
        }
      }]
    },

    columns () {
      return {
        name: 'Name',
        'user': {
          header: 'Borrower',
          format: ({ user }) => `${this.$_.get(user, 'profile.firstName')} ${this.$_.get(user, 'profile.lastName')}`
        },
        'financials.gdv': {
          header: 'GDV',
          format: project => this.$formatting.toCurrency(project.financials.gdv)
        },
        type: {
          header: 'Type',
          format: ({ type }) => this.$collection.getValue(require('../data/projectTypes.js').default, type)
        },
        units: 'Units',
        'financials.profit': {
          header: 'Gross Profit',
          format: project => this.$formatting.toCurrency(project.financials.profit)
        },
        projectedCompletionDate: {
          header: 'Completion Date',
          format: project => this.$dates.toDate(project.projectedCompletionDate)
        }
      }
    },

    filters () {
      if (this.hideFilters) {
        return {}
      }

      return {
        completed: {
          label: 'Completed',
          query: {
            status: 'Completed'
          }
        },
        ongoing: {
          label: 'Ongoing',
          query: {
            status: 'Ongoing'
          }
        },
        approved: {
          label: 'Approved',
          query: {
            status: 'Approved'
          }
        },
        submitted: {
          label: 'Submitted',
          query: {
            status: 'Submitted'
          }
        },
        pending: {
          label: 'Pending',
          query: {
            status: 'Pending'
          }
        },
        rejected: {
          label: 'Rejected',
          query: {
            status: 'Rejected'
          }
        }
      }
    }
  }
}
</script>
